var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98489 14.6118C9.50373 14.0942 9.50373 13.2544 8.98489 12.7362L3.20571 7.50022L8.98489 2.26427C9.50373 1.74604 9.50373 0.906878 8.98489 0.388672C8.46605 -0.129557 7.62564 -0.129558 7.1068 0.388672L0.383585 6.47939C0.103244 6.75973 -0.0203813 7.13311 0.00270715 7.50024C-0.0203813 7.86673 0.103244 8.24075 0.383585 8.52106L7.1068 14.6118C7.62564 15.1294 8.46602 15.1294 8.98489 14.6118Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackicon);
export default __webpack_public_path__ + "static/media/backicon.5c07af2636651ef7ef294ab946b33992.svg";
export { ForwardRef as ReactComponent };